export default function Footer() {
  return (
    <footer className="relative z-10 pb-12 text-center font-mono text-xs lowercase text-ink-soft">
      © {new Date().getFullYear()} temi otun
    </footer>
  );
}
